<template>
    <div>
        <div class="overlay_loading" v-if="!isLoaded">
            <div class="center_loading">
                <span>
                    <spinner text-fg-color="#ffffff" size="medium" message="Carregando sistema..."></spinner>
                </span>
            </div>
        </div>
        <div v-if="isLoaded">
            <div class="content-body" >
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-content">
                                <div class="card-body text-center mt-5 mb-5">
                                    <i class="ft-pie-chart text-muted" style="font-size: 4rem;"></i>
                                    <h3 class="mt-3">Para visualizar os indicadores e dashboards, acesse o <b>Looker</b>.</h3>
                                    <p class="text-muted">Todos os relatórios operacionais agora estão centralizados na plataforma de BI.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { formatCNPJFromParts } from "../utils";

import Vuetable from '../components/Vuetable'
import VuetablePagination from '../components/VuetablePagination'
import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
import VueClipboard from 'vue-clipboard2'
import ToggleButton from 'vue-js-toggle-button'
import accounting from 'accounting'
import moment from 'moment'
import vueDropzone from 'vue2-dropzone'
import VueCharts from 'vue-chartjs'
import LineChart from '../components/chart/LineChart'
import PieChart from '../components/chart/PieChart'

Vue.use(VueClipboard)
Vue.use(ToggleButton)

export default {
  components: {
      vueDropzone,
      LineChart,
      PieChart,
      VuetablePagination,
      VuetablePaginationInfo,
      Vuetable
  },
  data () {
      return {
        modal_titulo: '',
        modal_botao: '',
        modal_acao: '',
        datacollectionQtdeCtes: null,
        datacollection: null,
        showPopover: false,
        loading: false,
        loadedChart: false,
        disabled: false,
        isDisabled: false,
        loadingData: true,
        loadingDataUltimosCtes: true,
        showModal: false,
        isFullscreen: false,
        isFullscreenUltimosCtes: false,
        showModalPermission: false,
        showModalCadastroInicial: false,
        isFullscreenDashboard: false,
        optionsMunicipio: [],
        optionsParamTpDoc: [],
        isLoadingPeju: false,
        isLoadingPefi: false,
        total_tomadores: 0,
        unidade_documento: [],
        data_qtde_ctes: [],
        data_ultimos_ctes: [],
        data_vlr_tomador: [],
        formimprimir: new Form({
            doc_id: '',
            doc_id_pdf: [],
            doccte_id: '',
            tp_print: ''
        }),
        helpForm: new Form({params: [], search: ''}),
        fieldsUltimosCtes: [
          {
            name: 'num_fiscal',
            title: 'N° Fiscal',
            sortField: 'num_fiscal'
          },
          {
            name: 'serie',
            title: 'Série',
            sortField: 'serie'
          },
          {
            name: 'dt_emi',
            title: 'Data de emissão',
            callback: 'formatDate|DD/MM/YYYY HH:mm'
          },
          {
              name: '__slot:status',
              title: 'Status Doc'
          },
          {
              name: '__slot:status_sefaz',
              title: 'Status Sefaz'
          },
          {
              name: '__slot:actions',
              title: 'Ações',
              titleClass: 'center aligned',
              dataClass: 'center aligned'
          }
        ],
        css: {
            loadingClass: 'loading',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down',
            handleIcon: 'glyphicon glyphicon-menu-hamburger',
        },
        moreParams: {},
        errors_array: [],
       }
    },
    mounted() {
        // this.getData();
    },
    methods: {
        expandFullscreenDashboard() {
            this.isFullscreenDashboard = !this.isFullscreenDashboard;
        },
        expandFullscreenUltimosCtes() {
            this.isFullscreenUltimosCtes = !this.isFullscreenUltimosCtes;
        },
        onPaginationDataUltimosCtes (paginationData) {
          this.$refs.paginationUltimosCtes.setPaginationData(paginationData)
          this.$refs.paginationInfoUltimosCtes.setPaginationData(paginationData)
        },
        onChangePageUltimosCtes (page) {
          this.$refs.vuetable_ultimosctes.changePage(page)
        },
        onChangeStatusBFiscal(e) {
            this.form_integracao.status_integracao_bfiscal = e.value;
        },
        onChangeStatusCancelamento(e) {
            this.helpForm.status_canc_exp_erp  = e.value;
        },
        onChangeStatusCancelamentoFatura(e) {
            this.helpForm.status_canc_cte_com_fatura  = e.value;
        },
        onLoadedUltimosCtes: function () {
            this.dataExport = this.$refs.vuetable_ultimosctes.tableData;
            this.loadingDataUltimosCtes = false;
        },
        onFilterResetUltimosCtes () {
            this.loadingDataUltimosCtes = true;
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable_ultimosctes.refresh())
        },
        DateFormat: function(date) {
          if(date != null){
          return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          }
          return "";
        },
        disableByRef () {
            this.disabled = true;
        },
        formatNumber (value) {
            return accounting.formatNumber(value, 2, '.', ',')
        },
        getDataGraficos()
        {
            this.loading = true;
            this.isDisabled = true;
            this.helpForm.get('/api/dashboard/chart').then(response =>
            {
                this.data_qtde_ctes = response.qtde_ctes;
                this.data_ultimos_ctes = response.ultimos_ctes;
                this.data_vlr_tomador = response.vlr_tomador;

                // Vlr tomador
                if(response.vlr_tomador!==null)
                {
                    this.total_tomadores = 0;
                    response.vlr_tomador.forEach((obj)=>{
                        this.total_tomadores = this.total_tomadores+parseFloat( obj.total);
                    });

                    var va_labels = [];
                    var va_dataset = [];
                    this.data_vlr_tomador.forEach((obj)=>{
                        va_labels.push(obj.nome);
                        va_dataset.push(obj.total);
                    });

                    this.datacollection = {
                      //Data to be represented on x-axis
                      labels: va_labels,
                      datasets: [
                        {
                          label: '% Por valor',
                          backgroundColor: ['#f58742', '#f5e042', '#adf542', '#78f542', '#42f54b', '#42f5a4', '#42eff5', '#42a7f5', '#4272f5', '#5d42f5', '#00a8ff', '#16d39a', '#ffa87d', '#fca103', '#fc8003', '#fc6203', '#fc3503', 'fc1403', 'fc0303', '#f54242' ] ,
                          pointBackgroundColor: 'white',
                          borderWidth: 1,
                          pointBorderColor: '#249EBF',
                          data: va_dataset
                        }
                      ]
                    }
                }

                // qtde_ctes
                if(response.qtde_ctes!==null)
                {
                    var va_labels = [];
                    var va_dataset = [];
                    var va_dataset_cte = [];
                    this.data_qtde_ctes.forEach((obj)=>{
                        va_labels.push(obj.mes_ano);
                        va_dataset.push(obj.total);
                        va_dataset_cte.push(obj.vlr_total);
                    });
                    this.datacollectionQtdeCtes = {
                      //Data to be represented on x-axis
                      labels: va_labels,
                      datasets: [
                          {
                            label: 'Valor',
                            backgroundColor: '#249EBF' ,
                            pointBackgroundColor: 'white',
                            borderWidth: 1,
                            pointBorderColor: '#249EBF',
                            data: va_dataset_cte
                        },
                        {
                          label: 'CTEs gerados por mês',
                          backgroundColor: '#076bad' ,
                          pointBackgroundColor: 'white',
                          borderWidth: 1,
                          pointBorderColor: '#249EBF',
                          data: va_dataset
                      }
                   ],
                    }
                }
                this.loadedChart = true;
                this.loadingData = false;
            })
            .catch(errors =>
            {
                this.loadedChart = true;
                this.loadingData = false;
            });
        },
        getData() {
            this.helpForm.get('/api/dashboard/dados').then(response =>
            {
                this.getDataGraficos();
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
        formatDate(value, fmt = 'DD/MM/YYYY HH:mm') {
            return (value == null) ?
                '' :
                moment(value, 'YYYY-MM-DD HH:mm').format(fmt)
        },
        onError(response) {
            new ReturnApi(response.response, this, true, true, false);
        },
        onReloadResponse(response) {
            new ReturnApi(response, this);
        },
        limitText (count) {
          return ' e ${count} outros clientes'
        },
        onImprimirXml(doc_id, tp_print) {
            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.doc_id_pdf = [];
            if (tp_print == 2 || tp_print == 3) {
                this.$refs.vuetable.selectedTo.forEach((obj) => {
                    this.formimprimir.doc_id_pdf.push({
                        id: obj
                    })
                });
            } else if (tp_print == 1) {
                this.formimprimir.doc_id_pdf.push({
                    id: doc_id
                })
            }
            this.formimprimir.tp_print = tp_print;

            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.post('/api/cte/imprimircte').then(response => {
              new ReturnApi(response, this)
            })
            .catch(errors => {
              new ReturnApi(errors, this)
            });
        },
        onDownloadXml(doccte_id) {
            this.loading = true;
            this.isDisabled = true;
            this.formimprimir.doccte_id = doccte_id;
            this.formimprimir.post('/api/cte/downloadxml').then(response => {
                    new ReturnApi(response, this)
                })
                .catch(errors => {
                    new ReturnApi(errors, this)
                });
        },
                onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
          return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
        },
        getLivGeral() {
            this.helpForm.get('/api/dashboard/jsonlist').then(response =>
            {
                new ReturnApi(response, this, true, false, false);
                response.municipio.forEach((obj)=>
                {
                    this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
                })

                response.param_tp_doc.forEach((obj)=>
                {
                    this.optionsParamTpDoc.push({ label: obj.descr, value: obj.partipdoc_id })
                })
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
            });
        },
    },
    computed: {
        isLoaded: {
            get() {
                return this.$store.getters.isloaded;
            }
        },
        multi_empresa: {
            get() {
                return this.$store.getters.multi_empresa;
            }
        },
        introducao: {
            get() {
                return this.$store.getters.introducao;
            }
        },
        cadastro_inicial: {
            get() {
                return this.$store.getters.cadastro_inicial;
            }
        }
    }
}
</script>